import React, { Suspense } from 'react';
import { Center, Loader } from '@mantine/core';

// CodeMirror plus the SQL language mode is ~145 kB gzipped — about 10% of the whole bundle, on a
// build already flagged as oversized. Almost nobody opens Query Commander, so paying that on every
// page load to serve the handful of people editing SQL is the wrong trade.
//
// React.lazy pushes it into its own chunk that downloads on first render of the editor. Import
// this wrapper, never ./SqlEditor directly, or the split is silently undone: a single static
// import anywhere pulls CodeMirror back into the main bundle.
const SqlEditor = React.lazy(() => import('./SqlEditor'));

export default function LazySqlEditor(props) {
  return (
    <Suspense
      fallback={
        <Center h={props.height || '60vh'}>
          <Loader size="sm" />
        </Center>
      }
    >
      <SqlEditor {...props} />
    </Suspense>
  );
}
